<template>
  <v-row
    no-gutters
    class="LeasePeriodListItem role"
  >
    <v-col
      class="py-4 px-4 px-sm-6 pb-0 pb-sm-4"
      cols="12"
      sm="7"
      md="8"
      lg="9"
    >
      <h5 class="mb-3">
        {{ leasePeriod.name }}
      </h5>

      <div>
        <RcCalendarIcon style="padding-top: -10px" /> <span class="textSecondary--text">{{ convertDate(leasePeriod.start_date) }} - {{ convertDate(leasePeriod.end_date) }}</span>
      </div>

      <template v-if="leasePeriod.description">
        <div class="LeasePeriodListItem__divider" />

        <p
          class="textSecondary--text"
          v-html="leasePeriod.description"
        />
      </template>

      <!--      <RcBedIcon /> <span class="textSecondary&#45;&#45;text ml-3">10 beds available</span>-->

      <v-divider class="my-3 d-sm-none" />
    </v-col>
    <v-col
      class="LeasePeriodListItem__actions py-4 py-sm-8 px-4 px-sm-6 pt-0 pt-sm-4"
      cols="12"
      sm="5"
      md="4"
      lg="3"
    >
      <!--      <p class="textSecondary&#45;&#45;text mb-1">-->
      <!--        Payments from-->
      <!--      </p>-->

      <!--      <div class="LeasePeriodListItem__price font-weight-medium mb-4">-->
      <!--        $515-->
      <!--      </div>-->

      <div class="LeasePeriodListItem__footer d-flex d-sm-block align-center-sm">
        <v-btn
          class="flex-grow-1 text-left text-capitalize"
          color="primary"
          style="width: 200px"
          @click.native="$emit('apply', leasePeriod.id)"
        >
          <span v-if="leasePeriod.open_to_renewals">Open to Renewals</span>
          <span v-else-if="leasePeriod.allow_same_bed_renewals">Same Bed Renewals</span>
          <span v-else>Apply Now</span>

          <span class="flex-grow-1" />
          <v-icon end>
            chevron_right
          </v-icon>
        </v-btn>
        <div class="d-flex align-center mt-sm-3 ml-3 ml-sm-0">
          <RcFemaleIcon
            v-if="leasePeriod.genders_available.includes('F')"
            class="mr-3"
          />
          <RcMaleIcon v-if="leasePeriod.genders_available.includes('M')" />
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator'
import moment from 'moment'
import { LeasePeriod } from '../../../middleware/LeasePeriod'
import RcCalendarIcon from './RcCalendarIcon.vue'
import RcBedIcon from '../RcBedIcon.vue'
import RcFemaleIcon from './RcFemaleIcon.vue'
import RcMaleIcon from './RcMaleIcon.vue'

@Component({
  name: 'LeasePeriodListItem',
  components: { RcMaleIcon, RcFemaleIcon, RcBedIcon, RcCalendarIcon },
})
export default class LeasePeriodListItem extends Vue {
  @Prop({ required: true }) leasePeriod: LeasePeriod

  convertDate (date) {
    return moment(date, 'YYYY-MM-DD').format('MM-DD-YYYY')
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.LeasePeriodListItem {
  border-radius: 0.25rem;
  border: 1px solid var(--v-borderColor-base);
  background: var(--v-light-base);
  font-size: 14px;

  &__price {
    font-size: 18px;
  }
  &__actions {
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      border-left: 1px solid var(--v-borderColor-base);
    }
  }
  &__divider {
    width: 18px;
    border-top: 1px solid var(--v-primary-base);
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  &__actions {
    display: flex;
    align-items: center;
  }
}
</style>
